// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__D-OQ5","colMin":"styles_colMin__1y1aO","colCheckbox":"styles_colCheckbox__3BJKr"};